// extracted by mini-css-extract-plugin
export default {"imgContainer":"styleModule_imgContainer__bZBDb"};